import $ from 'jquery';
import { isValidImage } from '@/js/modules/file_validation';
import { prepareImagePreview, stripFileName } from '@/js/modules/uploads';
import templateContent from '../util/template_content';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const updateStyleImage = (data) => {
    $(`#questionnaire-style-image-${data.style_id}`).css(
      'background-image',
      `url(${data.image_url})`
    );
  };

  const checkAndToggleRemoveButton = ($ol) => {
    $ol
      .find('.questionnaire-form__input li button')
      .toggleClass('hide', $ol.find('.questionnaire-form__input').length === 1);
  };

  const toggleResetLink = (id, showOrHide) => {
    if (id === 'room-types') {
      $(`.dropdown-button__reset-form-input--${id}`)
        .closest('.dropdown-button--customize-questionnaire')
        .toggleClass('hide', showOrHide);
    }
    $(`.dropdown-button__reset-form-input--${id}`).toggleClass('hide', showOrHide);
  };

  const selectedTogglesCount = (id) => {
    const $checkboxGroup = $(`.questionnaire-form__${id}`);

    // fetch number of built in toggles
    const selectedBuiltinTogglesCount = $checkboxGroup.find(
      '.questionnaire-form__input:not(.questionnaire-form__input--custom) input[type="checkbox"]:checked'
    ).length;

    // fetch number of custom toggles *not* showing the input field
    const selectedCustomTogglesCount = $checkboxGroup
      .find('.questionnaire-form__field-container:not(:visible)')
      .filter((_, e) => {
        return (
          $(e).parents('.questionnaire-form__input--custom').find('input[type="checkbox"]:checked')
            .length > 0
        );
      }).length;

    return selectedBuiltinTogglesCount + selectedCustomTogglesCount;
  };

  const checkAndToggleResetLink = ($ol) => {
    const id = $ol.attr('class').split('__')[1];
    const values = $(`.questionnaire-form__${id}-list input`)
      .map((i, el) => $(el).val())
      .toArray();
    const defaultValues = $('#default-questionnaires').data('values')[id];

    const showOrHide =
      defaultValues.length === values.length &&
      defaultValues.every((el, index) => {
        return el === values[index];
      });
    toggleResetLink(id, showOrHide);
  };

  const checkAndToggleResetStyles = () => {
    const showOrHide =
      $('.questionnaire-form__style--new-custom-style').length === 0 &&
      $('.questionnaire-form__style--custom').length ===
        $(".questionnaire-form__destroy-custom-style[value='true']").length &&
      $('.questionnaire-form__style--default').length ===
        $('.green-checkbox--default-style:checked').length;
    toggleResetLink('styles', showOrHide);
  };

  $(document).on(
    'change paste keyup',
    `.field--timelines,
    .field--budget-ranges,
    .field--space-shared-with,
    .field--color-preferences-title,
    .field--color-preferences-description,
    .field--finished-states-title,
    .field--finished-states-description,
    .field--redesign-space-reasons,
    .field--kind-of-home`,
    (e) => {
      const $ol = $(e.target).parents('ol');
      checkAndToggleResetLink($ol);
    }
  );

  $(document).on(
    'click',
    `.questionnaire-form__remove-timeline,
     .questionnaire-form__remove-budget-range,
     .questionnaire-form__remove-space-shared-with,
     .questionnaire-form__remove-color-preferences,
     .questionnaire-form__remove-finished-states,
     .questionnaire-form__remove-redesign-space-reasons,
     .questionnaire-form__remove-kind-of-home`,
    (e) => {
      const $el = $(e.target);
      const $parentOl = $el.parents('ol');
      $el.parents('.questionnaire-form__input').remove();

      checkAndToggleRemoveButton($parentOl);
      checkAndToggleResetLink($parentOl);
    }
  );

  $(document).on('click', '.questionnaire-form__add-form-input', (e) => {
    e.preventDefault();

    const $ol = $(e.target).siblings('ol');
    const inputTemplate = $ol.find('div:first').clone();
    inputTemplate.find('input').attr('value', '').val('');

    const newInp = new Date().getTime();
    if ($ol.attr('class') === 'questionnaire-form__budget-ranges') {
      inputTemplate.find('input').attr('name', `questionnaire[budget_ranges][${newInp}][]`);
    }
    if ($ol.attr('class') === 'questionnaire-form__color-preferences') {
      inputTemplate.find('input').attr('name', `questionnaire[color_preferences][${newInp}][]`);
    }
    if ($ol.attr('class') === 'questionnaire-form__finished-states') {
      inputTemplate.find('input').attr('name', `questionnaire[finished_states][${newInp}][]`);
    }
    $ol.append(inputTemplate);
    checkAndToggleRemoveButton($ol);
    checkAndToggleResetLink($ol);
    $ol.find('div:last').find('input:first').focus();
  });

  $(document).on(
    'click',
    `
     .dropdown-button__reset-form-input--room-types,
     .dropdown-button__reset-form-input--moods
     `,
    (e) => {
      e.preventDefault();
      $(e.target)
        .closest('.questionnaire-form__question, .fieldset--questionnaire')
        .find('.questionnaire-form__input, .questionnaire-form__style')
        .find('input[type="checkbox"]')
        .prop('checked', true)
        .trigger('change');
    }
  );

  $(document).on('click', '.dropdown-button__reset-form-input--styles', (e) => {
    e.preventDefault();
    $.ajax({
      url: '/questionnaires/xhr_reset_default_styles_images',
      type: 'POST',
    }).done(() => {
      $('.questionnaire-form__style--default').each((_i, el) => {
        const imgEl = $(el).find('.questionnaire-style-image');
        const id = imgEl.attr('id').replace('questionnaire-style-image-', '');
        imgEl.css('background-image', `url(/img/projects-form/styles/${id}.jpg)`);
      });
      $('.questionnaire-form__style--new-custom-style').remove();
      $('.questionnaire-form__style--custom')
        .hide()
        .find('.questionnaire-form__destroy-custom-style')
        .val(true);
      $('.questionnaire-form__style--default')
        .find('.green-checkbox--styles')
        .prop('checked', true)
        .trigger('change');
      toggleResetLink('styles', true);
    });
  });

  $(document).on(
    'click',
    `
     .dropdown-button__reset-form-input--timelines,
     .dropdown-button__reset-form-input--budget-ranges,
     .dropdown-button__reset-form-input--finished-states,
     .dropdown-button__reset-form-input--space-shared-with,
     .dropdown-button__reset-form-input--redesign-space-reasons,
     .dropdown-button__reset-form-input--color-preferences,
     .dropdown-button__reset-form-input--kind-of-home
     `,
    (e) => {
      e.preventDefault();
      const $el = $(e.target);
      const $ol = $el.closest('fieldset').find('ol');
      $.get($el.attr('href'), (content) => {
        if ($el.hasClass('dropdown-button__reset-form-input--color-preferences')) {
          $('.green-checkbox--color-preferences').prop('checked', true);
        }
        if ($el.hasClass('dropdown-button__reset-form-input--finished-states')) {
          $('.green-checkbox--finished-states').prop('checked', true);
        }
        $ol.find('.questionnaire-form__input').remove();
        $ol.append(content);
        $el.addClass('hide');
      });
    }
  );

  $(document).on('change', '.questionnaire-style-image__replace-file-input', (e) => {
    const input = e.target;
    const file = input.files[0];
    const formData = new FormData();
    $(input).parents('.questionnaire-style-image').addClass('questionnaire-style-image-loader');
    formData.append('image', file);
    formData.append('style', $(input).attr('id'));
    formData.append('questionnaire_id', $('#hidden-questionnaire-id').val());
    $.ajax({
      url: '/questionnaires/xhr_replace_style_image',
      type: 'POST',
      contentType: false,
      processData: false,
      data: formData,
    }).done((data) => {
      if (data.error) {
        alert('Invalid image. Please upload a valid JPEG, PNG, WEBP, AVIF, GIF, or HEIC file.');
      } else {
        updateStyleImage(data);
        toggleResetLink('styles', false);
      }
      $(input)
        .parents('.questionnaire-style-image')
        .removeClass('questionnaire-style-image-loader');
    });
  });

  $(document).on('change', '.questionnaire-style-image__custom-style-image', (e) => {
    const input = e.target;
    const file = input.files[0];

    if (!isValidImage(file)) {
      alert('Unsupported images.');
      return false;
    }

    file.uploadName = stripFileName(file.name);
    $(input).parents('.questionnaire-style-image').addClass('questionnaire-style-image-loader');
    const reader = new FileReader();
    reader.onload = (event) => {
      prepareImagePreview(event.target.result, file.name, 88).then((imgData) => {
        if (imgData) {
          $(input)
            .parents('.questionnaire-style-image')
            .css('background-image', `url(${reader.result})`)
            .removeClass('questionnaire-style-image-loader')
            .removeClass('questionnaire-style-image--no-image');
        } else {
          $(input)
            .parents('.questionnaire-style-image')
            .removeClass('questionnaire-style-image-loader');
          alert('Invalid image. Please upload a valid JPEG, PNG, WEBP, AVIF, GIF, or HEIC file.');
        }
      });
    };
    reader.readAsDataURL(file);
  });

  $(document).on('change', '.green-checkbox--styles', (e) => {
    const $checkbox = $(e.target);
    const styleId = $checkbox.val();
    const $styleContainer = $checkbox.closest('.questionnaire-form__style');
    if ($checkbox.is(':checked')) {
      $(`#questionnaire-style-image-${styleId}`).addClass('questionnaire-style-image--active');
      $styleContainer
        .find('.questionnaire-style-image')
        .addClass('questionnaire-style-image--active');
      $styleContainer
        .find('.field--questionnaire-form-style')
        .removeClass('field--questionnaire-form-style-disabled');
    } else {
      $(`#questionnaire-style-image-${styleId}`).removeClass('questionnaire-style-image--active');
      $styleContainer
        .find('.questionnaire-style-image')
        .removeClass('questionnaire-style-image--active');
      $styleContainer
        .find('.field--questionnaire-form-style')
        .addClass('field--questionnaire-form-style-disabled');
    }
  });

  $(document).on('change', '.green-checkbox--room-types, .green-checkbox--moods', (e) => {
    const $checkbox = $(e.target);
    const id = $checkbox.hasClass('green-checkbox--moods') ? 'moods' : 'room-types';
    const $checkboxGroup = $(`.questionnaire-form__${id}`);

    // at least one toggle has to remain checked
    if (selectedTogglesCount(id) === 0 && !$checkbox.checked) {
      $checkbox.prop('checked', true);
    }
    toggleResetLink(
      id,
      $checkboxGroup.find('input[type="checkbox"]:checked').length ===
        $checkboxGroup.find('input[type="checkbox"]').length
    );

    // UI::Switch wraps the input in its own label, so the old next() sibling lookup finds nothing.
    const $label = $checkbox.closest('label');
    if ($checkbox.prop('checked')) {
      $label.removeClass('green-checkbox-label--unchecked');
    } else {
      $label.addClass('green-checkbox-label--unchecked');
    }
  });

  // add new option
  $(document).on('click', '.questionnaire-form__add-option', (e) => {
    const $option = document.getElementById($(e.target).data('option')).content.cloneNode(true);
    if ($(e.target).data('option') === 'multiple-choice-field') {
      const placeholderId = $(e.target).closest('.questionnaire-form__question').data('index');
      const newId = new Date().getTime();
      $($option)
        .find('.field--questionnaire-multiple-choice')
        .attr(
          'name',
          `questionnaire[custom_questions_attributes][${placeholderId}][custom_question_choices_attributes][${newId}][name]`
        )
        .attr(
          'id',
          `questionnaire_custom_questions_attributes_${placeholderId}_custom_question_choices_attributes_${newId}_name`
        );
    } else if ($(e.target).data('option') === 'multiple-choice-with-images-field') {
      const placeholderId = $(e.target).closest('.questionnaire-form__question').data('index');
      const newId = new Date().getTime();
      $($option)
        .find('.field--questionnaire-choice-with-image')
        .attr(
          'name',
          `questionnaire[custom_questions_attributes][${placeholderId}][custom_question_choices_attributes][${newId}][name]`
        )
        .attr(
          'id',
          `questionnaire_custom_questions_attributes_${placeholderId}_custom_question_choices_attributes_${newId}_name`
        );
      $($option)
        .find('.questionnaire-style-image__custom-style-image')
        .attr(
          'name',
          `questionnaire[custom_questions_attributes][${placeholderId}][custom_question_choices_attributes][${newId}][image]`
        )
        .attr(
          'id',
          `questionnaire_custom_questions_attributes_${placeholderId}_custom_question_choices_attributes_${newId}_image`
        );
    } else {
      const placeholderId = new Date().getTime();
      $($option)
        .find('input[type="checkbox"]')
        .attr('id', placeholderId)
        .attr('checked', true)
        .closest('label')
        .removeClass('green-checkbox-label--unchecked');
    }
    $(e.target).before($option);
    $(e.target).prev('.questionnaire-form__input').find('.field').focus();
    return false;
  });

  // add custom style
  $(document).on('click', '.questionnaire-form__add-option--custom-style', (e) => {
    const $option = document.getElementById($(e.target).data('option')).content.cloneNode(true);
    const placeholderId = new Date().getTime();
    $($option)
      .find('.questionnaire-style-image__custom-style-image')
      .attr('name', `questionnaire[custom_styles_attributes][${placeholderId}][image]`)
      .attr('id', `questionnaire_custom_styles_attributes_${placeholderId}_image`);
    $($option)
      .find('.field--questionnaire-form-style')
      .attr('name', `questionnaire[custom_styles_attributes][${placeholderId}][style]`)
      .attr('id', `questionnaire_custom_styles_attributes_${placeholderId}_style`);
    $($option)
      .find('.green-checkbox--styles')
      .attr('name', `questionnaire[custom_styles_attributes][${placeholderId}][active]`)
      .attr('id', `questionnaire_custom_styles_attributes_${placeholderId}_active`);
    $($option)
      .find('.green-checkbox-label--questionnaire-style')
      .attr('for', `questionnaire_custom_styles_attributes_${placeholderId}_active`);
    $(e.target).before($option);
    $(e.target).prev('.questionnaire-form__style').find('.field').focus();
    toggleResetLink('styles', false);
    return false;
  });

  $(document).on('keyup paste change', '.field--questionnaire-form-style', (e) => {
    const container = $(e.target).closest('.questionnaire-form__style');
    const style = $(e.target).val();
    if (style.length > 0) {
      const defaultStyles = $.map($('.questionnaire-style-image__style-name'), (el, _) =>
        $(el).text()
      );
      const customStyles = $.map($('.field--questionnaire-form-style').not($(e.target)), (el, _) =>
        $(el).val()
      );
      if (defaultStyles.includes(style) || customStyles.includes(style)) {
        container.find('.error-message').text('This style already existed.').show();
        container
          .find('.questionnaire-style-image')
          .removeClass('questionnaire-style-image--active');
        container.find('.green-checkbox--styles').prop('checked', false).val(0);
      } else {
        container.find('.error-message').text('').hide();
        container.find('.questionnaire-style-image').addClass('questionnaire-style-image--active');
        container.find('.green-checkbox--styles').prop('checked', true).val(1);
      }
    } else {
      container.find('.error-message').text('Style cannot be blank.').show();
      container.find('.questionnaire-style-image').removeClass('questionnaire-style-image--active');
      container.find('.green-checkbox--styles').prop('checked', false).val(0);
    }
  });

  $(document).on('input', '.field--new-room, .field--new-mood', (e) => {
    const value = $(e.target).val();
    $(e.target).toggleClass('field--error', value === '');
    $(e.target)
      .closest('.questionnaire-form__input')
      .find('input[type="checkbox"]')
      .val(value.toLowerCase().replace(/\s/gim, '-'));
  });
  $(document).keypress(function (e) {
    $(e.target).removeClass('field--error');
    if (
      e.which === 13 &&
      ($('.field--new-room').is(':focus') || $('.field--new-mood').is(':focus'))
    ) {
      const value = $(e.target).val().trim();
      if (value === '') {
        $(e.target).addClass('field--error');
        return false;
      }
      $(e.target)
        .closest('.questionnaire-form__field-container')
        .hide()
        .closest('label')
        .find('.green-checkbox-label__room-type')
        .text(value)
        .css('display', 'inline')
        .end()
        .find('.green-checkbox-label__mood')
        .text(value)
        .css('display', 'inline');
      $(e.target)
        .closest('.questionnaire-form__input')
        .find('input[type="checkbox"]')
        .val(value.toLowerCase().replace(/\s/gim, '-'));
      return false;
    }
  });

  // delete custom space option
  $(document).on(
    'click',
    '.questionnaire-form__delete-room, .questionnaire-form__delete-mood',
    (e) => {
      const $this = $(e.target);

      let id;
      if ($this.hasClass('questionnaire-form__delete-room')) {
        id = 'room-types';
      } else if ($this.hasClass('questionnaire-form__delete-mood')) {
        id = 'moods';
      }

      if (selectedTogglesCount(id) === 0) {
        alert('At least one option has to remain selected');
      } else {
        $this.closest('.questionnaire-form__input').remove();
      }

      return false;
    }
  );

  // click to edit space option
  $(document).on(
    'click',
    '.questionnaire-form__input--custom .green-checkbox-label__room-type, .questionnaire-form__input--custom .green-checkbox-label__mood',
    (e) => {
      // show only one input at a time
      if ($('.questionnaire-form__field-container:visible').length) {
        return false;
      }

      $(e.target).hide();
      $(e.target)
        .closest('.questionnaire-form__input')
        .find('.questionnaire-form__field-container')
        .show();
      return false;
    }
  );

  // remove custom style option
  $(document).on('click', '.questionnaire-form__delete-new-style', (e) => {
    $(e.target).closest('.questionnaire-form__style').remove();
    checkAndToggleResetStyles();
    return false;
  });

  $(document).on('click', '.questionnaire-form__delete-custom-style', (e) => {
    e.preventDefault();
    $(e.target)
      .closest('.questionnaire-form__style')
      .hide()
      .find('.questionnaire-form__destroy-custom-style')
      .val(true);
    checkAndToggleResetStyles();
  });

  // expand qeustion if it's header is clicked
  $(document).on(
    'click',
    '.questionnaire-form__question:not(.questionnaire-form__question--opened)',
    (e) => {
      if ($(e.target).hasClass('dropdown-button__reset-form-input')) {
        return false;
      }
      const $el = $('.questionnaire-form__question--opened');
      $('.questionnaire-form__question--opened')
        .removeClass('questionnaire-form__question--opened')
        .removeClass('questionnaire-form__question--grey-background')
        .find('.questionnaire-form__question-header')
        .toggleClass(
          'questionnaire-form__question-header--grey-color',
          $el.hasClass('questionnaire-form__question--hidden')
        )
        .show()
        .end()
        .find('.field--questionnaire-title')
        .removeClass('field--questionnaire-title-active')
        .end()
        .find('.dropdown-button--customize-questionnaire')
        .hide()
        .end()
        .find('.questionnaire-form__content')
        .slideUp(250)
        .end()
        .find('.df-tooltip--hide-question')
        .toggleClass('hide', !$el.hasClass('questionnaire-form__question--hidden'))
        .end()
        .find('.questionnaire-form__custom-question-name')
        .show()
        .end()
        .find('.questionnaire-form__sortable-handle')
        .removeClass('questionnaire-form__sortable-handle--opened');

      $(e.currentTarget)
        .addClass('questionnaire-form__question--opened')
        .toggleClass(
          'questionnaire-form__question--grey-background',
          $(e.currentTarget).hasClass('questionnaire-form__question--hidden')
        )
        .find('.questionnaire-form__question-header')
        .removeClass('questionnaire-form__question-header--grey-color')
        .hide()
        .end()
        .find('.field--questionnaire-title')
        .addClass('field--questionnaire-title-active')
        .end()
        .find('.dropdown-button--customize-questionnaire')
        .show()
        .end()
        .find('.questionnaire-form__content')
        .slideDown(250)
        .end()
        .find('.df-tooltip--hide-question')
        .toggleClass('hide', !$(e.currentTarget).hasClass('questionnaire-form__question--hidden'))
        .end()
        .find('.questionnaire-form__custom-question-name')
        .hide()
        .end()
        .find('.questionnaire-form__sortable-handle')
        .addClass('questionnaire-form__sortable-handle--opened');
    }
  );

  // click to hide question
  $(document).on('change', '.dropdown-button__checkbox--hide-question', (e) => {
    $('.error-message').hide();
    const container = $(e.target).closest('.questionnaire-form__question');
    container
      .toggleClass('questionnaire-form__question--hidden')
      .toggleClass('questionnaire-form__question--grey-background')
      .find('.field--questionnaire-title')
      .toggleClass('field--questionnaire-title-disabled')
      .end()
      .find('.df-tooltip--hide-question')
      .toggleClass('hide')
      .end()
      .find('.new-question-hidden-active')
      .val(!$(e.target).prop('checked'));

    // make sure question is not required any longer
    const $requiredDropdown = $(e.target)
      .closest('.dropdown-button__dropdown')
      .find('.dropdown-button__checkbox--required-question');
    if ($(e.target).prop('checked') && $requiredDropdown.prop('checked')) {
      $requiredDropdown.prop('checked', false).trigger('change');
    }
  });

  // click on button to create new question
  $(document).on('click', '.s-button--new-question, .s-button--new-bottom-question', () => {
    const $newQuestion = $(document.getElementById('new-question').content.cloneNode(true));
    const placeholderId = new Date().getTime();

    $newQuestion
      .find('.questionnaire-form__question')
      .attr('data-index', placeholderId)
      .attr('data-order', placeholderId);
    // Because new custom questions don't have ID yet, we'll use `order_id` field instead
    // This field is saved only on creating new question, and can not be edited
    $newQuestion
      .find('.new-question-hidden-order-id')
      .attr('name', `questionnaire[custom_questions_attributes][${placeholderId}][order_id]`)
      .attr('id', `questionnaire_custom_questions_attributes_${placeholderId}_order_id`)
      .val(placeholderId);
    $newQuestion
      .find('.new-question-required')
      .attr('name', `questionnaire[custom_questions_attributes][${placeholderId}][required]`)
      .attr('id', `questionnaire_custom_questions_attributes_${placeholderId}_required`);
    $newQuestion
      .find('.dropdown-button__checkbox--required-question')
      .attr('id', `new_question_${placeholderId}_required`);
    $newQuestion
      .find('.dropdown-button__item--required-question')
      .find('.dropdown-button__item--checkbox')
      .attr('for', `new_question_${placeholderId}_required`);
    $newQuestion
      .find('.new-question-hidden-active')
      .attr('name', `questionnaire[custom_questions_attributes][${placeholderId}][active]`)
      .attr('id', `questionnaire_custom_questions_attributes_${placeholderId}_active`);
    $newQuestion
      .find('.dropdown-button__checkbox--hide-question')
      .attr('id', `new_question_${placeholderId}_active`);
    $newQuestion
      .find('.dropdown-button__item--hide-question')
      .find('.dropdown-button__item--checkbox')
      .attr('for', `new_question_${placeholderId}_active`);
    $newQuestion
      .find('.field--questionnaire-title')
      .attr('name', `questionnaire[custom_questions_attributes][${placeholderId}][name]`)
      .attr('id', `questionnaire_custom_questions_attributes_${placeholderId}_name`);
    $newQuestion
      .find('.field--questionnaire-description')
      .attr('name', `questionnaire[custom_questions_attributes][${placeholderId}][description]`)
      .attr('id', `questionnaire_custom_questions_attributes_${placeholderId}_description`);
    $newQuestion
      .find('.custom-dropdown__input--new-q')
      .attr('name', `questionnaire[custom_questions_attributes][${placeholderId}][kind]`);
    $('.questionnaire-form__question').last().after($newQuestion);

    $('.questionnaire-form__question')
      .last()
      .find('.field--questionnaire-title')
      .trigger('click')
      .focus()
      .select();
    return false;
  });

  // select queston type from the dropdown
  $(document).on('change', '.custom-dropdown__input--new-q', (e) => {
    $(e.target)
      .closest('.questionnaire-form__content')
      .find('.error-message--question-kind')
      .text('')
      .hide();
    const $newQuestionContainer = $(e.target)
      .closest('.questionnaire-form__content')
      .find('.questionnaire-form__new-question-container');
    const placeholderId = $(e.target).closest('.questionnaire-form__question').data('index');
    const $newQuestion = document
      .getElementById(`new-question-${$(e.target).val().replace(/[_]/gim, '-')}`)
      .content.cloneNode(true);

    $newQuestionContainer
      .attr('class', 'questionnaire-form__new-question-container')
      .empty()
      .addClass(
        `questionnaire-form__new-question-container--${$(e.target).val().replace(/[_]/gim, '-')}`
      )
      .append($newQuestion);

    $newQuestionContainer
      .find('.checkbox--alow-multiple')
      .attr(
        'name',
        `questionnaire[custom_questions_attributes][${placeholderId}][multiple_selections]`
      )
      .attr('id', `questionnaire_custom_questions_attributes_${placeholderId}_multiple_selections`);
    $newQuestionContainer
      .find('.checkbox__label--allow-multiple')
      .attr(
        'for',
        `questionnaire_custom_questions_attributes_${placeholderId}_multiple_selections`
      );
    if (['multiple_choice', 'multiple_choice_with_images'].includes($(e.target).val())) {
      for (let i = 0; i < 4; i++) {
        $newQuestionContainer.find('.questionnaire-form__add-option').click();
      }
    } else {
      $newQuestionContainer
        .find('.field')
        .first()
        .attr('name', $(e.target).attr('name').replace('[kind]', '[placeholder]'))
        .focus();
    }
  });

  // delete option for multiple choice type question
  $(document).on('click', '.questionnaire-form__delete-multiple-choice', (e) => {
    $(e.target).siblings('.questionnaire-form__destroy-custom-question-choice').val(true);
    $(e.target).closest('.questionnaire-form__multiple-choice').hide();
    return false;
  });

  $(document).on('click', '.questionnaire-form__delete-new-choice-option', (e) => {
    $(e.target).closest('.questionnaire-form__multiple-choice').remove();
    return false;
  });

  // delete new custom question
  $(document).on('click', '.dropdown-button__item--delete-new-question', (e) => {
    $(e.target).closest('.questionnaire-form__question').remove();
    return false;
  });

  $(document).on('click', '.dropdown-button__item--delete-custom-question', (e) => {
    e.preventDefault();
    const container = $(e.target).closest('.questionnaire-form__question');
    const questionId = container.data('id');
    const projectsPresent = container.data('projects-present');
    if (projectsPresent) {
      const modal = templateContent(
        document.getElementById('questionnaire-delete-custom-question')
      );
      modal.querySelectorAll('[data-remove-question]').forEach((button) => {
        button.addEventListener('click', () => {
          container.hide().find('.questionnaire-form__destroy-custom-question').val(true);
          if (button.dataset.removeAnswers) {
            $(`#destroy-project-custom-questions--${questionId}`).prop('checked', true);
          }
        });
      });
      document.body.append(modal);
    } else {
      container.hide().find('.questionnaire-form__destroy-custom-question').val(true);
    }
  });

  // duplicate new custom question
  $(document).on('click', '.dropdown-button__item--duplicate-new-question', (e) => {
    const $queston = $(e.target).closest('.questionnaire-form__question');
    const placeholderId = new Date().getTime();
    const $questonClone = $queston.clone();
    $questonClone
      .find('.dropdown-button__checkbox--hide-question')
      .attr('id', `hide-question--${placeholderId}`);
    $questonClone
      .find('.dropdown-button__item--checkbox')
      .attr('for', `hide-question--${placeholderId}`);
    if ($questonClone.find('.questionnaire-form__style').length > 0) {
      $questonClone.find('.questionnaire-form__style').each(function (index, item) {
        const placeholderId = new Date().getTime() + index;
        $(item).find('input[type="checkbox"]').attr('id', placeholderId);
      });
    }
    $queston.after($questonClone);
    $questonClone
      .removeClass('questionnaire-form__question--opened')
      .find('.field--questionnaire-title')
      .trigger('click');
    return false;
  });

  $(document).on('change', '.green-checkbox--color-preferences', (e) => {
    $('.field--color-preferences-description').toggleClass('hide');
  });
  $(document).on('change', '.green-checkbox--finished-states', (e) => {
    $('.field--finished-states-description').toggleClass('hide');
  });

  $(document).on(
    'click',
    '.h-s-button--save-and-preview-questionnaire, .p-button--save-questionnaires',
    (e) => {
      $('.error-message').hide();
      let validationFailed = false;
      let $firstInvalidQuestion = null;
      let $firstValidationError = null;

      const showValidationError = ($error) => {
        validationFailed = true;
        $error.show();
        if (!$firstValidationError) {
          $firstValidationError = $error;
        }

        const $question = $error.closest('.questionnaire-form__question');
        if (!$firstInvalidQuestion && $question.length) {
          $firstInvalidQuestion = $question;
        }
      };

      const openQuestion = ($question) => {
        if ($question.length && !$question.hasClass('questionnaire-form__question--opened')) {
          $question.trigger('click');
        }
      };

      const questionNameError = ($field) => {
        const $content = $field.closest('.questionnaire-form__content');
        let $error = $content.find('.error-message--question-name').first();

        if ($error.length === 0) {
          $error = $('<div class="error-message error-message--question-name"></div>');
          $field.after($error);
        }

        return $error;
      };

      const scrollToValidationError = () => {
        const $visibleError = $firstValidationError?.is(':visible')
          ? $firstValidationError
          : $('.error-message:visible:first');
        const $scrollTarget = $visibleError.length ? $visibleError : $firstInvalidQuestion;

        if (!$scrollTarget?.length) {
          return;
        }

        $('body,html').animate(
          {
            scrollTop: $scrollTarget.offset().top - 120,
          },
          800
        );
      };

      if ($('.field--questionnaire-title-header').val().trim().length === 0) {
        showValidationError(
          $('.field--questionnaire-title-header')
            .next()
            .html('Please provide a questionnaire title')
        );
      }

      if (
        $('.questionnaire-form__content--welcome-message').length &&
        !$('.dropdown-button__checkbox--hide-welcome-message').is(':checked')
      ) {
        if ($('.field--questionnaire-welcome-headline').val().length === 0) {
          showValidationError(
            $('.field--questionnaire-welcome-headline')
              .next()
              .html('Please provide a welcome headline')
          );
        }
        if ($('.field--questionnaire-welcome-message-text-area').val().length === 0) {
          showValidationError(
            $('.field--questionnaire-welcome-message-text-area')
              .next()
              .html('Please provide a welcome message')
          );
        }
        if ($('.field--questionnaire-welcome-button-label').val().length === 0) {
          showValidationError(
            $('.field--questionnaire-welcome-button-label')
              .next()
              .html('Please provide a button label')
          );
        }
      }

      if (
        $('.dropdown-button__checkbox--hide-question:checked').length ===
        $('.questionnaire-form__question').length
      ) {
        showValidationError(
          $('.error-message--questionnaire-form').html('You can not hide all the questions.')
        );
      } else if (
        !$('.dropdown-button__checkbox--hide-welcome-message').is(':checked') &&
        $('.dropdown-button__checkbox--hide-question:checked').length ===
          $('.questionnaire-form__question').length - 1
      ) {
        showValidationError(
          $('.error-message--questionnaire-form').html(
            'Please make an additional question available in order to save your Questionnaire.'
          )
        );
      }

      const questionsOrder = [];
      $('#questionnaire-form-sortable')
        .find('.questionnaire-form__question')
        .each((_i, el) => {
          const destroyEl = $(el).find('.questionnaire-form__destroy-custom-question');
          if (destroyEl.length === 0 || String(destroyEl.val()) === 'false') {
            questionsOrder.push($(el).data('order'));
          }
        });
      $('#questionnaire-questions-order').val(questionsOrder);

      $('.error-message--question-name').text('').hide();
      $('.error-message--question-kind').text('').hide();

      $('.field--questionnaire-title').each((_i, el) => {
        const title = $(el).val().trim();
        if (title.length === 0 || title === 'Enter your question...') {
          const $error = questionNameError($(el)).text('Please provide question title');

          showValidationError($error);
        }
      });

      $('.custom-dropdown__trigger').each((_i, el) => {
        if ($(el).text() === 'Response Format') {
          const $question = $(el).closest('.questionnaire-form__question');
          $question.find('.error-message--question-kind').text('Please select response type');

          showValidationError($question.find('.error-message--question-kind'));
        }
      });

      $('.questionnaire-form__question').each((_i, question) => {
        const $question = $(question);
        const $imageChoices = $question.find('.field--questionnaire-choice-with-image');

        if ($imageChoices.length === 0) {
          return;
        }

        const filledChoicesCount = $imageChoices.filter((_j, choice) =>
          $(choice).val().trim()
        ).length;

        if (filledChoicesCount < 2) {
          $imageChoices.each((_j, choice) => {
            if (!$(choice).val().trim()) {
              showValidationError(
                $(choice).closest('.questionnaire-form__choice-with-image').find('.error-message')
              );
            }
          });

          $question.find('.error-message--question-kind').text('Must have at least 2 answers');
          showValidationError($question.find('.error-message--question-kind'));
        }
      });

      $('.custom-dropdown__input[value=multiple_choice]:checked').each((_i, el) => {
        let count = 0;
        const $question = $(el).closest('.questionnaire-form__question');

        $question.find('.field--questionnaire-multiple-choice').each((_i, choice) => {
          if ($(choice).val().trim()) {
            count += 1;
          }
        });

        if (count < 2) {
          $question.find('.error-message--question-kind').text('Must have at least 2 answers');

          showValidationError($question.find('.error-message--question-kind'));
        }
      });

      const openedInvalidQuestion =
        $firstInvalidQuestion &&
        !$firstInvalidQuestion.hasClass('questionnaire-form__question--opened');

      if (openedInvalidQuestion) {
        openQuestion($firstInvalidQuestion);
      }

      if (validationFailed || $('.error-message:visible').length) {
        setTimeout(scrollToValidationError, openedInvalidQuestion ? 260 : 0);

        return false;
      }
    }
  );

  $(document).on('keyup paste change', '.field--questionnaire-choice-with-image', (e) => {
    $(e.target).closest('.questionnaire-form__choice-with-image').find('.error-message').hide();
  });

  const canDeleteImageChoice = ($question) => {
    if ($question.find('.questionnaire-form__multiple-choice-with-images:visible').length > 2) {
      return true;
    }

    $question.find('.error-message--question-kind').text('Must have at least 2 answers').show();
    return false;
  };

  $(document).on('keyup paste change', '.field--questionnaire-title', (e) => {
    $(e.target)
      .closest('.questionnaire-form__question')
      .find('.questionnaire-form__custom-question-name')
      .text($(e.target).val());
    if ($(e.target).val().length === 0 || $(e.target).val() === 'Enter your question...') {
      $(e.target)
        .closest('.questionnaire-form__content')
        .find('.error-message--question-name')
        .text('Please provide question title')
        .show();
    } else {
      $(e.target)
        .closest('.questionnaire-form__content')
        .find('.error-message--question-name')
        .text('')
        .hide();
    }
  });

  $(document).on('click', '.questionnaire-form__delete-new-choice-with-image', (e) => {
    e.preventDefault();
    const $question = $(e.target).closest('.questionnaire-form__question');

    if (!canDeleteImageChoice($question)) {
      return false;
    }

    $(e.target).closest('.questionnaire-form__multiple-choice-with-images').remove();
  });

  $(document).on('click', '.questionnaire-form__delete-choice-with-image', (e) => {
    e.preventDefault();
    const $question = $(e.target).closest('.questionnaire-form__question');

    if (!canDeleteImageChoice($question)) {
      return false;
    }

    $(e.target).siblings('.questionnaire-form__destroy-choice-with-image').val(true);
    $(e.target).closest('.questionnaire-form__multiple-choice-with-images').hide();
  });

  $(document).ready(() => {
    $('#questionnaire-form-sortable').sortable({
      handle: '.questionnaire-form__sortable-handle',
      cursor: 'move',
      tolerance: 'pointer',
    });
  });

  $(document).on('change', '.dropdown-button__checkbox--required-question', (e) => {
    const container = $(e.target).closest('.questionnaire-form__question');
    container.find('.new-question-required').val($(e.target).prop('checked'));
    const $hideDropdown = $(e.target)
      .closest('.dropdown-button__dropdown')
      .find('.dropdown-button__checkbox--hide-question');
    if ($(e.target).prop('checked') && $hideDropdown.prop('checked')) {
      $hideDropdown.prop('checked', false).trigger('change');
    }
    $(e.target)
      .closest('.questionnaire-form__question')
      .find('.df-tooltip--required-question')
      .toggleClass('hide', !$(e.target).prop('checked'));
  });

  $(document).on('click', '.questionnaire-form__reset-all', (e) => {
    e.preventDefault();
    document.body.append(
      templateContent(document.getElementById('questionnaire-reset-confirmation'))
    );
  });

  $(document).on('click', '.dropdown-menu__link--delete-questionnaire', (e) => {
    e.preventDefault();
    const { title, deleteUrl } = e.currentTarget.dataset;
    const modal = templateContent(document.getElementById('questionnaire-delete-confirmation'));
    modal.querySelector('[data-questionnaire-title]').textContent = title;
    modal.querySelector('form').action = deleteUrl;
    document.body.append(modal);
  });

  $(document).on('click', '.dropdown-menu__link--print-questionnaire', (e) => {
    const questionnaireLink = $(e.target).attr('href');
    const printWindow = open(questionnaireLink);
    printWindow.printView = true;
    return false;
  });

  $(document).on('click', '.p-button--questionnaire-template-form', (e) => {
    const $titleField = $('.field--questionnaire-template-title');
    if (!$titleField.val()) {
      e.preventDefault();
      $('.error-message--questionnaire-template-title').show();
    }
  });

  $(document).on(
    'click',
    '.dropdown-menu__link--create-questionnaire, .dropdown-menu__link--duplicate-questionnaire',
    () => {
      $('.modal--duplicate-questionnaire').modal();
    }
  );

  $(document).on('click', '.project-details__questionnaire-print-link', function (e) {
    const $target = $(e.currentTarget);
    const $questionnaire = $target.closest('.df-accordion');

    // Add print-specific class to apply print styles to the questionnaire
    $questionnaire.addClass('print-questionnaire');

    // Safari browser compatibility fix for printing:
    // window.print() does not work reliably in Safari.
    // Using document.execCommand('print') as the primary method for Safari,
    // with window.print() as a fallback for other browsers.
    // Reference: https://stackoverflow.com/questions/31171099/window-print-does-not-work-in-safari
    try {
      if (!document.execCommand('print', false, null)) {
        window.print();
      }
    } catch {
      window.print();
    }

    // Remove the print class after triggering the print dialog
    $questionnaire.removeClass('print-questionnaire');
    return false;
  });
});
